export default "__VITE_ASSET__BvDXBUH2__"